export enum RADIO_CARD_CONST {
  TEST_ID = 'radio-card',
}
